import { createSlice } from '@reduxjs/toolkit';

import { type SearchTermResponse } from 'schemas';
import { fetchSearchTerms } from './searchTermsThunks';
import { SEARCH_TERMS_SLICE_NAME } from '../slicesNames';
import { type SearchTermsState } from './searchTerms.types';

const initialState: SearchTermsState = {
  isLoading: false,
  error: null,
  nameMap: {
    provider: {},
    facility: {},
  },
};

const searchTermsSlice = createSlice({
  name: SEARCH_TERMS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchSearchTerms.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSearchTerms.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch services';
      })
      .addCase(fetchSearchTerms.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;

        const { provider = [], facility = [] } = action.payload as SearchTermResponse;

        for (const providerTerm of provider) {
          state.nameMap.provider[providerTerm.searchTerm.toLowerCase()] = providerTerm;
        }

        for (const facilityTerm of facility) {
          state.nameMap.facility[facilityTerm.searchTerm.toLowerCase()] = facilityTerm;
        }
      });
  },
});

export default searchTermsSlice;
